export enum SortingMode {
  CLIENT = 'client',
  SERVER = 'server',
}
